// extracted by mini-css-extract-plugin
module.exports = {"formsInfo":"styles_formsInfo__3zQ3H","formsInfoSelected":"styles_formsInfoSelected__1nao-"};